module.exports = __webpack_public_path__ + "img/latitude.d395e977.jpg";